
<template>
  <div>
    <div class="danghang-every">
      <div class="mainContainer">
        <span>当前位置：</span><span style="padding: 0 5px;cursor: pointer;">通知公告</span>/<span style="padding: 0 5px;">公告详情</span>
      </div>
    </div>
    <div class="noticeDetail mainContainer">
      <div class="noticeDetail-tit">{{noticeData.zname}}</div>
      <div class="disFlex between" style="color: #9a9a9a;padding-bottom: 20px;border-bottom: 1px solid #dfdfdf;;">
        <div>阅读量：{{noticeData.yueducount}}</div>
        <div>{{noticeData.createTime}}</div>
      </div>
      <div style="margin-top: 20px;line-height: 25px;font-size: 14px;letter-spacing: 1px;text-align: left;padding: 20px;"
      v-html="noticeData.cunt">
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Notice',
    data() {
      return {
        noticeData: {}
      }
    },
    methods: {
      // 跳转详情
      getDetail: function(id) {
        this.$axios.get('/kt/wz/ktNotify/detail.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.noticeData = data.data;
          } else {
            this.$message.error(data.message);
          }
        })
      }
    },
    created: function() {
      this.getDetail(sessionStorage.getItem('noticeId'));
    }
  }
</script>

<style>
  .noticeDetail {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px;
    margin-top: 20px;
  }

  .noticeDetail-tit {
    opacity: 1;
    font-size: 40px;
    font-weight: 700;
    color: #333333;
    line-height: 60px;
    letter-spacing: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/NoticeDetail.vue